import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const RiskAssessment: React.FC = () => {
  const sections = [
    {
      title: 'Comprehensive Risk Assessment Services',
      content: 'Our risk assessment services provide organizations with a thorough understanding of their cybersecurity risk landscape. We identify, analyze, and prioritize security risks across your entire IT infrastructure, helping you make informed decisions about risk mitigation strategies and security investments.',
      benefits: [
        'Comprehensive asset inventory and classification',
        'Threat modeling and vulnerability identification',
        'Risk quantification and impact analysis',
        'Regulatory compliance risk assessment',
        'Business impact analysis and continuity planning'
      ]
    },
    {
      title: 'Risk Assessment Methodology',
      content: 'Our proven risk assessment methodology follows industry best practices and standards including NIST, ISO 27005, and FAIR (Factor Analysis of Information Risk) frameworks.',
      benefits: [
        'Asset identification and valuation',
        'Threat landscape analysis',
        'Vulnerability assessment and testing',
        'Risk calculation and prioritization',
        'Mitigation strategy development'
      ]
    },
    {
      title: 'Deliverables and Outcomes',
      content: 'Our risk assessments deliver actionable insights and clear recommendations to help you strengthen your security posture and achieve your business objectives.',
      benefits: [
        'Detailed risk register with prioritized findings',
        'Executive summary with business impact analysis',
        'Risk mitigation roadmap and recommendations',
        'Compliance gap analysis and remediation plan',
        'Ongoing risk monitoring and review processes'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Assessment Duration',
      content: 'Typical risk assessments take 4-8 weeks depending on organizational scope and complexity.'
    },
    {
      title: 'Industry Standards',
      content: 'Our assessments align with NIST Cybersecurity Framework, ISO 27001, and industry-specific regulations.'
    },
    {
      title: 'Expert Team',
      content: 'Our certified risk analysts have extensive experience across multiple industries and threat landscapes.'
    }
  ];

  return (
    <ServiceTemplate
      title="Risk Assessment"
      subtitle="Comprehensive cybersecurity risk assessments to identify, analyze, and prioritize security risks across your organization."
      sections={sections}
      ctaTitle="Start Your Risk Assessment"
      ctaDescription="Get a clear understanding of your cybersecurity risks and develop an effective risk management strategy."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default RiskAssessment;

